import { cn } from "@/lib/utils";

const HBranchLine = ({ active }: { active: boolean }) => {
  return (
    <span
      className={cn(
        "absolute left-0 top-1/2 w-[7px] border-t",
        active ? "border-violet-700" : "border-gray-300",
      )}
      aria-hidden="true"
    />
  );
};

export default HBranchLine;
